import * as React from 'react';

import iconUrl from './ActionIcon.svg';

export const ActionIcon = () => <img width="39" height="39" src={iconUrl} alt="" />;

ActionIcon.displayName = 'ActionIcon';
